import { schema } from "normalizr";

const ModuleSchema = new schema.Entity("modules");

const ModuleArraySchema = new schema.Array(ModuleSchema);

export {
  ModuleSchema,
  ModuleArraySchema
};